export default {"src":"/_next/static/media/setting.4e718488.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};